export default __webpack_public_path__ + "locales/fr/InfoPanel.json?hash=7c74ccd3c488fad364deddf8708a13d3";